export const boxStyle = {
    px: 2,
    display: 'flex',
    minHeight: '90vh',
    textAlign: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: '#f2f5fc',
}
